import { reactive } from "vue";

//글로벌 전역변수
export const globalState = reactive({
    isLoading : false,
    corpNo    : "",
    cusId    : "",
    seq    : "",
    exchange : {}
});
 
